"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Video = void 0;
const react_1 = __importDefault(require("react"));
const media_1 = require("./media");
const Video = (props) => {
    return react_1.default.createElement(media_1.Media, Object.assign({}, props, { elementType: "video" }));
};
exports.Video = Video;
